// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState, useCallback, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import makeWorkshop from '../../redux/selectors/workshopInformationSelector';
import getWorkshopDataActions from '../../redux/actionCreators/workshop/getWorkshopDataActions';
import updateWorkshopProgressActions from '../../redux/actionCreators/workshop/updateWorkshopProgressActions';
import MainLayout from '../../layouts/MainLayout';
import LoadingIcon from '../../components/LoadingIcon';
import { S } from './WorkshopPageStyle';
import Row from '../../components/Row';
import DomainLabel from '../../components/DomainLabel';
import Column from '../../components/Column';
import { parseDuration } from '../../lib/utility';
import moment from 'moment';
import Contents, { ContentsFromType } from '../../components/ContentsListComponent/Contents';
import ErrorPage from '../ErrorPage';
import TimeUpImg from '../../assets/images/timeup_workshop.svg';
import FinishedBadgeIcon from '../../assets/images/card-badge.svg';
import { InfoTextType } from '../../components/NewCard/components/InfoText';
import { WorkshopInformation, Progress } from '../../types/Model';
import { FormattedMessage } from 'react-intl';
import { FetchingParams } from '../../types/Common';
import { downloadWorkshopResult } from '../../apis/workshop';
import { dashboardDetail, postDashboardDownloadDetail } from '../../apis/base';
import DownloadNotion from './components/DownloadNotion';
import DownloadResultModal from '../../components/DownloadResultModal';
import MemberContext from '../../contexts/MemberContext';
import * as XLSX from 'xlsx';

enum StatusEnum {
  firstTime = 'D002',
  comingSoon = 'D003',
  keepGoing = 'D004',
  finish = 'D005',
  end = 'D006'
}

function getWorkshopStatus(workshopData: WorkshopInformation) {
  const now = new Date().getTime();
  const startTime = workshopData.startTime.getTime();
  const endTime = workshopData.endTime.getTime();

  const isComingSoon = now < startTime;
  const isInProgress = startTime < now && now < endTime;

  if (isComingSoon) {
    return StatusEnum.comingSoon;
  } else if (isInProgress) {
    if (workshopData.completionProgress === 0) {
      return StatusEnum.firstTime;
    } else if (workshopData.completionProgress === 1) {
      return StatusEnum.finish;
    }

    return StatusEnum.keepGoing;
  }

  return StatusEnum.end;
}

type Status = StatusEnum.firstTime | StatusEnum.finish | StatusEnum.comingSoon | StatusEnum.keepGoing | StatusEnum.end;

const useFetchWorkshopInformation = (id: number, params?:FetchingParams) => {
  const dispatch = useDispatch();
  const preventLoading = params && params.preventLoading;
  const callback = params && params.callback;

  const fetch = useCallback(() => {
    dispatch(getWorkshopDataActions.request({ id, preventLoading }))
    callback && callback();
  }, [id, preventLoading, callback])

  return fetch;
}

function useUpdateProgress(id: number): (progress: Progress) => void {
  const dispatch = useDispatch();
  const refetchContents = useFetchWorkshopInformation(id, { preventLoading: true });

  return useCallback((progress: Progress) => {
    dispatch(updateWorkshopProgressActions.request({
      id,
      progress,
      onSuccess: () => refetchContents()
    }))
  }, [id])
}

const WorkshopPage = (): JSX.Element => {
  const params = useParams<{ id: string }>();
  const id = parseInt(params.id, 10);
  const member = useContext(MemberContext);
  const isFetching = useSelector(makeWorkshop.makeIsFetchingWorkshop());
  const workshopData = useSelector(makeWorkshop.makeWorkshopByIdSelector(id));
  const { domainIds = [], chapters = [] } = workshopData;
  const errors = useSelector(makeWorkshop.makeError());
  const [status, setStatus] = useState<Status>(StatusEnum.comingSoon);
  const [isChooseDownload, setIsChooseDownload] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState('');
  const [downloadError, setdownloadError] = useState(false);
  const [downloadFileName, setDownloadFileName] = useState('');
  const fetchWorkshop = useFetchWorkshopInformation(id);
  const updateProgress = useUpdateProgress(id);

  useEffect(() => {
    fetchWorkshop();
  }, [id]);

  useEffect(() => {
    if (!workshopData.startTime) {
      return;
    }

    setStatus(getWorkshopStatus(workshopData));
  }, [workshopData]);

  function renderButton(id: number) {
    if (status === StatusEnum.firstTime || status === StatusEnum.keepGoing || status === StatusEnum.finish) {
      return (
        <S.Button
          as={Link}
          to={`/workshops/${id}/contents`}
        >
          <FormattedMessage id={status} />
        </S.Button>
      );
    }

    return (
      <S.Button disabled={(status === StatusEnum.comingSoon || status === StatusEnum.end)}>
        <FormattedMessage id={status} />
      </S.Button>
    )
  }

  const handleDownloadResult = async (choosedUser: any) => {
    setIsChooseDownload(false);
    setIsDownloading(true);
    await downloadWorkshopResult(id, choosedUser)
      .then(reponse => {
        if (reponse.headers['content-disposition']) {
          const filename = reponse.headers['content-disposition'].split(';')[1].split('=')[1];
          setDownloadFileName(filename);
          const excelblob = new Blob([reponse.data], { type: 'application/vnd.ms-excel'});
          const downloadUrl = window.URL.createObjectURL(excelblob);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          setDownloadUrl(downloadUrl);
        }
        setIsDownloading(false);
        setTimeout(() => {
          setDownloadUrl('');
          setdownloadError(false);
        }, 15000);
      })
      .catch(error => {
        console.log(error);
        setIsDownloading(false);
        setdownloadError(true);
        setTimeout(() => {
          setdownloadError(false);
        }, 5000);
      });
  }

  const fitToColumn = (data: any) => {
    return data[0].map((a: any, i: any) => ({ wch: Math.max(...data.map((a2: any) => {
      const width = a2[i] ? a2[i].toString().length : 0
      return width === 0 ? 8 : width
    })) }));
  }

  const handleDownloadCompleteResult = async (completeRateWithScore: boolean) => {
    setIsChooseDownload(false);
    setIsDownloading(true);
    const type = 'workshop'
    let orgId = 0;
    if (member.organizationId) {
      orgId = member.organizationId;
    }
    await dashboardDetail(orgId, type, id).then(async (res) => {
      const completeDetail = res.data;
      let totalTask = 0;
      Object.values(completeDetail.overviewResponse.detailNumber).map((item: any) => totalTask+=item);
      const titleList: any = [];
      Object.keys(completeDetail?.overviewResponse.detailNumber).map((item: any) => {
        if (parseInt(completeDetail?.overviewResponse.detailNumber[item]) !== 0) {
          titleList.push(item);
        }
      })
      completeDetail?.userProgressDetail.map((member: any) => {
        let totalTaskProgress: any = 0;
        titleList.map((task: any) => {
          if (member[task] > completeDetail.overviewResponse.detailNumber[task]) {
            totalTaskProgress += completeDetail.overviewResponse.detailNumber[task];
          } else {
            totalTaskProgress += member[task];
          }
        })
        member.completeRate = totalTaskProgress > totalTask ? 100 : parseFloat((totalTaskProgress/totalTask*100).toFixed(2))
        delete member.jobCategory;
        delete member.jobLevel;
      })
      const workbook = XLSX.utils.book_new();
      const columnList: any = ['member', 'department', 'completeRate'];
      const rowList: any = [];
      titleList.map((item: string) => {
        columnList.push(item)
      })

      completeDetail.userProgressDetail.map((item: any) => {
        const tmpList: any = [];
        tmpList.push(item.email, item.department, item.completeRate);
        titleList.map((task: string) => {
          tmpList.push(item[task]);
        })
        rowList.push(tmpList)
      })
      const detailList = Object.entries(completeDetail.overviewResponse.detailNumber)
      for (const i in detailList) {
        if (i >= rowList.length) {
          const emptyCell = columnList.map((item: string) => '')
          rowList.push([...emptyCell, ...['', '', ...detailList[i]]])
        } else {
          rowList[i].push(...['', '', ...detailList[i]])
        }
      }
      columnList.push(...['', '', 'type', 'count'])
      const worksheet = XLSX.utils.aoa_to_sheet([columnList, ...rowList]);
      worksheet['!cols'] = fitToColumn([columnList, ...rowList]);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Complete Rate');

      if (completeRateWithScore) {
        await postDashboardDownloadDetail(orgId, id, type.replace(/([A-Z])/g, ' $1').replace(/^./, type[0].toUpperCase()), 'detail', workshopData.name)
          .then(response => {
            const scoreList = response.data;
            if (scoreList && scoreList.exam && scoreList.exam.title.length > 0) {
              const examColumnList: any = scoreList.exam.title.map((title: any) => title.name);
              const examRowList = scoreList.exam.item;
              const worksheet = XLSX.utils.aoa_to_sheet([examColumnList, ...examRowList]);
              worksheet['!cols'] = fitToColumn([examColumnList, ...examRowList]);
              XLSX.utils.book_append_sheet(workbook, worksheet, 'Exam_Result');
            }
            if (scoreList && scoreList.assessment && scoreList.assessment.title.length > 0) {
              const assessmentColumnList: any = scoreList.assessment.title.map((title: any) => title.name);
              const assessmentRowList = scoreList.assessment.item;
              const assessmentInfoList = scoreList.assessment.info;

              for (const i in assessmentInfoList) {
                if (i >= rowList.length) {
                  const emptyCell = assessmentColumnList.map((item: string) => '')
                  assessmentRowList.push([...emptyCell, ...['', '', ...assessmentInfoList[i]]])
                } else {
                  assessmentRowList[i].push(...['', '', ...assessmentInfoList[i]])
                }
              }
              assessmentColumnList.push(...['', '', 'Id', 'Assessment Name'])
              const worksheet = XLSX.utils.aoa_to_sheet([assessmentColumnList, ...assessmentRowList]);
              worksheet['!cols'] = fitToColumn([assessmentColumnList, ...assessmentRowList]);
              XLSX.utils.book_append_sheet(workbook, worksheet, 'Assessment_Result');
            }
          });
      }
      const excelFile = XLSX.write(workbook, { type: 'buffer' });
      const link = document.createElement('a');
      const blobData = new Blob([excelFile]);
      // eslint-disable-next-line
      link.download = `${workshopData.name.replace(/[*?:\\/[\]]/g, '').replaceAll(' ', '_')}.xlsx`;
      link.href = window.URL.createObjectURL(blobData);
      link.click();
      setDownloadFileName(`${workshopData.name.replace(/[*?:\\/[\]]/g, '').replaceAll(' ', '_')}.xlsx`);
      setDownloadUrl(window.URL.createObjectURL(blobData));
      setIsDownloading(false);
      setTimeout(() => {
        setDownloadUrl('');
        setdownloadError(false);
      }, 15000);
    })
  }

  function renderDownloadButton() {

    let isDisable = false;
    if (status === StatusEnum.comingSoon || status === StatusEnum.end) {
      isDisable = true;
    }
    return (
      <>
        { isDownloading ? (
          <S.DownloadLoadingContainer>
            <LoadingIcon size={5} />
          </S.DownloadLoadingContainer>
        ):(
          <>
            { downloadUrl !== '' ? (
              <S.DownloadResultContainer>
                <S.DownloadText>
                  <FormattedMessage id="D030" values={{ br: <br /> }}/>
                  <S.DownloadButton href={downloadUrl} download={downloadFileName} target="_blank">
                    <FormattedMessage id="D031" values={{ br: <br /> }}/>
                  </S.DownloadButton>
                </S.DownloadText>
              </S.DownloadResultContainer>
            ):(
              <S.DownloadResultContainer>
                <S.DownloadButtonContainer>
                  <S.Button onClick={() => setIsChooseDownload(true)} disabled={isDisable}>
                    <FormattedMessage id="D029" />
                  </S.Button>
                  <DownloadNotion />
                </S.DownloadButtonContainer>
                { isChooseDownload ? <DownloadResultModal courseData={workshopData.workshopUserList} setIsChooseDownload={setIsChooseDownload} handleDownloadMemberResult={handleDownloadResult} handleDownloadCompleteResult={handleDownloadCompleteResult}/> : null }
                <S.ErrorText downloadError={downloadError}>
                  <FormattedMessage id="D032" values={{ br: <br /> }} />
                </S.ErrorText>
              </S.DownloadResultContainer>
            )}
          </>
        )}
      </>
    )
  }

  if (isFetching) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <LoadingIcon size={20} />
        </S.LoadingContainer>
      </MainLayout>
    );
  }

  if (errors) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <ErrorPage />
        </S.LoadingContainer>
      </MainLayout>
    );
  }

  if (status === StatusEnum.end) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <S.TimeUpContainer alignX="center" alignY="center">
            <S.Img src={TimeUpImg} alt="" />
            <S.TimeUp>
              <FormattedMessage id="D019" values={{ br: <br/>}} />
            </S.TimeUp>
            <Link to="/home">
              <S.TimeUpButton ><FormattedMessage id="D023" /></S.TimeUpButton>
            </Link>
          </S.TimeUpContainer>
        </S.LoadingContainer>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <S.WrapperTop bannerUrl={workshopData.bannerUrl}>
        <S.Container>
          <Row alignX="between">
            <S.LeftWrapper>
              <S.Title color="Black">{workshopData.name}</S.Title>
              <S.Time>
                <FormattedMessage id="D001" />：{moment(workshopData.startTime).format('YYYY/MM/DD HH:mm')} - {moment(workshopData.endTime).format('YYYY/MM/DD HH:mm')}
              </S.Time>
              <S.Domains>
                {
                  domainIds.map((domainId: number) => (
                    <DomainLabel key={domainId} domainId={domainId} />
                  ))
                }
              </S.Domains>
            </S.LeftWrapper>
            <S.RightWrapper>
              {status === StatusEnum.finish && <S.Badge src={FinishedBadgeIcon} alt="" />}
              <S.Information color="Black">{workshopData.description}</S.Information>
            </S.RightWrapper>
          </Row>
        </S.Container>
      </S.WrapperTop>
      <S.Body>
        <S.Container>
          <Row>
            <S.InfoBox>
              {renderButton(workshopData.id)}
              {workshopData.isWorkshopOwner ? renderDownloadButton() : null}
              <S.Info>
                <S.LevelMeter levelId={workshopData.levelId} showName={true} namePosition="left" /><S.Point> ・ </S.Point> {workshopData.language}
              </S.Info>
              <Column gap={12}>
                <S.InfoText type={InfoTextType.DURATION}><FormattedMessage id="D011" />{parseDuration(workshopData.totalDuration).auto}</S.InfoText>
                {workshopData.vodCount != 0 && (<S.InfoText type={InfoTextType.VOD}><FormattedMessage id="D012" values={{ count: workshopData.vodCount}} /></S.InfoText>)}
                {workshopData.labCount != 0 && (<S.InfoText type={InfoTextType.LAB}><FormattedMessage id="D013" values={{ count: workshopData.labCount}} /></S.InfoText>)}
                {workshopData.challengeCount != 0 && (<S.InfoText type={InfoTextType.CHALLENGE}><FormattedMessage id="D025" values={{ count: workshopData.challengeCount}} /></S.InfoText>)}
                {workshopData.examCount != 0 && (<S.InfoText type={InfoTextType.EXAM}><FormattedMessage id="D028" values={{ count: workshopData.examCount}} /></S.InfoText>)}
                {workshopData.assessmentCount != 0 && (<S.InfoText type={InfoTextType.ASSESSMENT}><FormattedMessage id="D014" values={{ count: workshopData.assessmentCount }} /></S.InfoText>)}
              </Column>
            </S.InfoBox>
            <S.Contents>
              <Contents handleUpdateProgress={updateProgress} chapters={chapters} id={id} contentsFrom={ContentsFromType.WORKSHOP} isOwned={status !== StatusEnum.comingSoon} />
            </S.Contents>
          </Row>
        </S.Container>
      </S.Body>
    </MainLayout>
  )
}
export { WorkshopPage as default };
